/* eslint-disable */
export default {
  conferenceCall: '电话会议',
  onHold: '暂候',
  ongoing: '正在进行',
  unknown: '未知',
  disconnected: '已断开连接',
  loading: '正在加载…',
  loadingTimeout: '加载超时。',
} as const;

// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
// @key: @#@"onHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"ongoing"@#@ @source: @#@"Ongoing"@#@
// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"disconnected"@#@ @source: @#@"Disconnected"@#@
// @key: @#@"loading"@#@ @source: @#@"Loading ..."@#@
// @key: @#@"loadingTimeout"@#@ @source: @#@"Loading timeout."@#@
